import type { BaseApiErrorResponse, HttpStatus } from '../types/api.types';

export default class BaseApiResponseError<TErrors> {
  #errors: TErrors | null;
  #status: HttpStatus;
  #message: string;
  #code?: string;
  #userMembershipId?: string;
  #endDate?: string;
  #existingCheckIn?: BaseApiErrorResponse<TErrors>['existingCheckIn'];
  #currentAssignment?: BaseApiErrorResponse<TErrors>['currentAssignment'];
  #disabledNumberId?: string;
  constructor({
    code,
    currentAssignment,
    disabledNumberId,
    endDate,
    errors,
    existingCheckIn,
    message,
    status,
    userMembershipId,
  }: BaseApiErrorResponse<TErrors>) {
    this.#errors = errors;
    this.#message = message;
    this.#status = status;
    this.#code = code;
    this.#userMembershipId = userMembershipId;
    this.#endDate = endDate;
    this.#existingCheckIn = existingCheckIn;
    this.#currentAssignment = currentAssignment;
    this.#disabledNumberId = disabledNumberId;
  }

  get message() {
    return this.#message;
  }

  get errors() {
    return this.#errors;
  }

  get status() {
    return this.#status;
  }

  /** machine-readable BE error code (e.g. NO_SAVED_CARD) */
  get code() {
    return this.#code;
  }

  /** Task 5 — set only on MEMBERSHIP_VISITS_USED_UP. */
  get userMembershipId() {
    return this.#userMembershipId;
  }

  /** Task 5 — set only on MEMBERSHIP_VISITS_USED_UP. */
  get endDate() {
    return this.#endDate;
  }

  /** Set only on MEMBERSHIP_ALREADY_CHECKED_IN_TODAY. */
  get existingCheckIn() {
    return this.#existingCheckIn;
  }

  /** Set only on LOCKER_KEY_HOLDER_HAS_KEY. */
  get currentAssignment() {
    return this.#currentAssignment;
  }

  /** Set only on LOCKER_KEY_ALREADY_DISABLED. */
  get disabledNumberId() {
    return this.#disabledNumberId;
  }
}
